import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Contact />
      <Footer />
    </div>;
}